import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';

const RewriteQaRulesModal = ({
  show,
  title,
  helperText,
  placeholder,
  submitLabel = 'Rewrite',
  submittingLabel = 'Rewriting…',
  sectionLabel,
  extraContent,
  rewriting,
  requiresSave = true,
  onHide,
  onSubmit
}) => {
  const [instruction, setInstruction] = useState('');

  useEffect(() => {
    if (show) setInstruction('');
  }, [show]);

  const heading = `${title || 'Rewrite with AI'}${sectionLabel ? ` — ${sectionLabel}` : ''}`;
  const canSubmit = Boolean(instruction.trim()) && !rewriting;

  return (
    <Modal show={show} onHide={rewriting ? undefined : onHide} centered backdrop="static" style={{ zIndex: 99999 }}>
      <Modal.Header>
        <Modal.Title>
          <h6 className="mb-0">{heading}</h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted tinyFont mb-2">
          {helperText ||
            'Existing rules and documents are kept and updated unless you ask to replace them.'}
        </p>
        {requiresSave && (
          <p className="tinyFont mb-2" style={{ color: '#b45309' }}>
            Please note: rules are not saved by default. Click Save to update the rules.
          </p>
        )}
        {extraContent}
        <Form.Group className="mb-0">
          <Form.Label className="tinyFont font-weight-bold">
            {title ? 'Why is this wrong?' : 'What should change?'}
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={5}
            autoFocus
            disabled={rewriting}
            value={instruction}
            placeholder={placeholder || 'To the existing rules, I want the following change…'}
            onChange={e => setInstruction(e.target.value)}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button size="sm" variant="outline-secondary" disabled={rewriting} onClick={onHide}>
          Cancel
        </Button>
        <Button
          size="sm"
          variant="info"
          className="d-inline-flex align-items-center"
          disabled={!canSubmit}
          onClick={() => onSubmit(instruction.trim())}
        >
          {rewriting && <Spinner size="sm" animation="border" className="mr-1" />}
          {rewriting ? submittingLabel : submitLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RewriteQaRulesModal;
